import { Component, input } from '@angular/core';
import { MenuItem } from '@openng/optimus-ui/api';
import { MenuModule } from '@openng/optimus-ui/menu';
import { NgClass, NgTemplateOutlet } from '@angular/common';

@Component({
    selector: 'app-drop-down-menu',
    templateUrl: 'drop-down-menu.component.html',
    styleUrl: 'drop-down-menu.component.scss',
    imports: [
        MenuModule,
        NgTemplateOutlet,
        NgClass,
    ]
})
export class DropDownMenuComponent {

    public target = input<any>();
    public items = input<MenuItem[]>([]);
    public appendTo = input<string>('body');
    public disabled = input(false);

}
